<template>
  <div>
    <div class="">
      <b-tabs lazy fill Justified @activate-tab="changeTab">
        <b-tab title="Quản lý QR">
          <QR />
        </b-tab>
        <b-tab title="Quản lý QR VA">
          <QRVA />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
  import QR from './listQr.vue'
  import QRVA from './listQrVa.vue'

  export default {
    name: 'QRTABS',
    computed: {
      activeTab() {
        return this.$route.query.tab === '2' || 0
      },
    },
    methods: {
      changeTab(tab) {
        this.$router.push({ query: { tab: tab } })
      },
    },
    components: { QR, QRVA },
  }
</script>
